import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService"



const fetchSubcontractors = async () => {
    const { data } = await apiInputService.get("/subcontractor");
    return data as any[];
};

export const useSubcontractors = () => {
    const { subscription } = useSubscription();

    return useQuery(["subcontractors", subscription?.subscriptionId], fetchSubcontractors, {
        refetchOnWindowFocus: true,
        enabled: !!subscription?.subscriptionId,
    });

}